import { messageChannel } from '@/utils/messageChannel'
import { getStore } from '@/utils/dva'

export const gylFrameReady = () => {
    return new Promise(resolve => {
        if (window.__POWERED_BY_GYL_FRAME__) {
            messageChannel.receiveMessage('global/window', data => {
                window.__POWERED_BY_GYL_FRAME__ = true
                Object.keys(data).forEach(key => {
                    window[key] = data[key]
                })
                resolve()
            })
            messageChannel.postMessage('global/ready')
        } else {
            resolve()
        }
    })
}

export const setShowBackTop = value => {
    if (window.__POWERED_BY_GYL_FRAME__) {
        messageChannel.postMessage('global/dispatch', { type: 'global/setShowBackTop', payload: value })
    } else {
        const $store = getStore()
        $store.dispatch({
            type: 'global/setShowBackTop',
            payload: value
        })
    }
}
